<template>
  <div id="app">
    <headerBlock @mobnav="mobileNav" :class="{'navFixed' : mob_nav_active}">
    <div class="headPhone">
      +380991044900
    </div>
      <nav>
        <router-link class="navLink" to="/">{{ navHome[lang()] }}</router-link>
        <router-link class="navLink" to="/services">{{ navService[lang()] }}</router-link>
        <router-link class="navLink" to="/keys">{{ navCases[lang()] }}</router-link>

        <b-form-select
          style="width: 60px; color: rgb(255, 193, 7); background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.2)); border-radius: 5px;"
          v-model="selected"
          :options="options"
          @change="changeLang"
          size="sm"
        >
        </b-form-select>
      </nav>
      <div v-if="mob_nav_active" class="mobNavActive">
        <ul class="mob_ul">
          <li @click="mob_nav_active = !mob_nav_active">
            <router-link class="mobLink" to="/">{{ navHome[lang()] }}</router-link>
          </li>
          <li @click="mob_nav_active = !mob_nav_active">
            <router-link class="mobLink" to="/services">{{ navService[lang()] }}</router-link>
          </li>
          <li @click="mob_nav_active = !mob_nav_active">
            <router-link class="mobLink" to="/keys">{{ navCases[lang()] }}</router-link>
          </li>
          <li>
            <b-form-select
              style="width: 30vw;  color: rgb(255, 193, 7); background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(255, 255, 255, 0.2)); border-radius: 5px;"
              v-model="selected"
              :options="options"
              @change="changeLang"
              >
              </b-form-select>
          </li>
        </ul>
      </div>
    </headerBlock>
    <transition name="anim_section">
      <router-view></router-view>
    </transition>
     <footer>
       <span>©2020 - {{ thisYear }} by FUNBASE</span>
     </footer>
  </div>
</template>

<script>
import { store } from './store.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import headerBlock from './components/Header.vue';
export default {
  name: 'app',
  data () {
    return {
      mob_nav_active: false,
      selected: null,
      options: [
        { value: 'ua', text: 'UA' },
        { value: 'en', text: 'EN' }
      ],
      thisYear: new Date().getFullYear()
    }
  },
  created() {
    this.selected = localStorage.getItem('lang')
  },
  components: {
      headerBlock
    },
  methods: {
    mobileNav() {
      this.mob_nav_active = !this.mob_nav_active
    },
    changeLang() {
      localStorage.setItem('lang', this.selected);
      location.reload();
    },
    lang() {
      return localStorage.getItem('lang');
    },
  },
  computed: {
    width() {
      return store.window.w
    },
    navHome() {
      return store.navHome
    },
    navService() {
      return store.navService
    },
    navCases() {
      return store.navCases
    },
    navContacts() {
      return store.navContacts
    }
  }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  background: linear-gradient(180deg, #0B0C1D, #1A1B3D);
}
h3, h6 {
  color: #FFFFFF;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.router-link-exact-active {
  color: #fff !important;
  text-decoration: underline;
  font-weight: bold;
}
.services-custom-button {
  background: #FF497A; /* Неоновий рожевий */
  color: #fff;
  border: none;
  transition: 0.3s;
}
.services-custom-button:focus {
  background: #FF497A;
  color: #fff;
  border: none;
  transition: 0.3s;
  outline: none;
}
.services-custom-button:hover {
  background: #FF1855; /* Темніший відтінок */
  box-shadow: 0 0 15px #FF497A;
  transform: scale(1.05);
  color: #fff;
}
.navLink {
  color: rgb(255, 193, 7);
  text-transform: uppercase;
  transition: 0.5s;
  margin-left: 15px;
}
.headPhone {
  color: #fff;
}
.navLink:hover {
  color: gray;
  text-decoration: none;
}
.anim_section-enter-active {
  animation: anim_section-in .2s;
}
.anim_section-leave-active {
  animation: anim_section-in .3s reverse;
}
.mobNavActive {
  width: 100%;
  height: 95vh;
  /*background: #263238;*/
  background: linear-gradient(135deg, #0c0c1e, #1e1e2e);
  position: fixed;
  z-index: 99;
  top: 10vh;
  left: 0;
}
.navFixed {
  position: fixed;
  z-index: 990;
  width: 100%;
  border-bottom: 1px solid #6c757d;
}
.mob_ul {
    list-style: none;
    padding: 3rem;
    text-align: center;
    padding: 4rem 0 0 0;
    display: flex;
    height: 95vh;
    flex-direction: column;
}
.mob_ul > li {
  margin-bottom: 2rem;
}
.mobLink {
  color: rgb(255, 193, 7);
  font-size: 1.5rem;
}
.mobLink:hover {
    color: rgb(255, 193, 7);
}
@keyframes anim_section-in {
  0%{
    transform:scaleY(0);
    opacity: 0;
    transform-origin:top;
    height: 0px;
  }
  100%{
    opacity: 1;
    transform:scaleY(1);
    transform-origin:top;
    height: calc(100vh - 10vh)
  }
}
footer {
  height: 2rem;
  /*background-color: #263238;*/
  background: linear-gradient(90deg, #511B75, #FF6B00);
  width: 100vw;
  position: fixed;
  bottom: 0;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 767px) {
  nav {
    display: none;
  }
  section {
    padding-top: 10vh;
  }
  footer {
    display: none;
  }
  .headPhone {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue